'use strict';

module.exports = String.fromCharCode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar-date/common/var/chr.js
// module id = 79
// module chunks = 1